import { registerCrossOriginServiceWorker } from '@fullstory/service-worker-registration';
import { getPlaybackDomain } from '@fullstory/util/domains';

export const registerPlaybackServiceWorker = () => {
  const playbackDomain = getPlaybackDomain(window.location.host);
  const registrationPageHref = `https://${playbackDomain}/s/register-playback-service-worker.html`;
  return registerCrossOriginServiceWorker(registrationPageHref);
};
